import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

export const accountTypeGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  
  const requiredAccountType = route.data['accountType'] as string;
  if (!requiredAccountType) {
    return true;
  }
  if (requiredAccountType === authService.getAccountType()) {
    return true;
  }
  return router.parseUrl('/login');
};
